import { customizeValidator } from '@rjsf/validator-ajv8';

// "radio" and "enum" are UI hints in the stored form schemas, not validation formats.
const validator = customizeValidator({ customFormats: { radio: /.*/, enum: /.*/ } });

export default validator;
